import type { DashboardResponse } from "../lib/types";
import { request } from "./client";

export function fetchDashboard(signal?: AbortSignal): Promise<DashboardResponse> {
  return request<DashboardResponse>("/api/v1/dashboard", signal ? { signal } : {});
}
